import { useState } from 'react';

import { Grid } from '@mui/material';
import { FieldOwnerState } from '@mui/x-date-pickers';
import { DateRangePicker, MultiInputDateRangeField } from '@mui/x-date-pickers-pro';

import { StoreAutoComplete } from 'components/autocompletes';
import { CissNumberField } from 'components/fields';
import { Filter } from 'components/filter';
import { FilterValuesProps } from 'hooks/useFilter';

export function NotaDevolucaoListFilter() {
    const [filterInterval, setFilterInterval] = useState<FilterValuesProps>({
        property: 'dtFiltro',
        operator: 'bt',
        startDate: null,
        endDate: null,
        required: 'Intervalo de emissão é obrigatório',
    });

    const [filterLoja, setFilterLoja] = useState<FilterValuesProps>({
        property: 'cdCliente', // ao alterar propriedade lembrar de alterar leitura dela no método getDsLoja tela listagem nota devolução
        operator: 'eq',
        value: null,
        idProperty: 'cdLoja',
        required: 'Loja é obrigatória',
    });

    const [filterCodigo, setFilterCodigo] = useState<FilterValuesProps>({
        property: 'nrOrdemVenda',
        operator: 'eq',
        value: '',
    });

    return (
        <Filter
            preventQueryParamsEmptyStart
            filters={[
                { value: filterInterval, setter: setFilterInterval },
                { value: filterLoja, setter: setFilterLoja },
                { value: filterCodigo, setter: setFilterCodigo },
            ]}
        >
            <Grid sx={{ flex: 1 }}>
                <StoreAutoComplete
                    value={filterLoja.value}
                    onChange={(e, value) => setFilterLoja((oldState: FilterValuesProps) => ({ ...oldState, value }))}
                />
            </Grid>

            <Grid sx={{ width: '100%', flex: 2 }}>
                <DateRangePicker
                    value={[filterInterval.startDate ?? null, filterInterval.endDate ?? null]}
                    onChange={([startDate, endDate]) => {
                        setFilterInterval((oldState: FilterValuesProps) => ({
                            ...oldState,
                            startDate,
                            endDate,
                        }));
                    }}
                    slots={{ field: MultiInputDateRangeField }}
                    slotProps={{
                        field: { dateSeparator: 'até' },
                        textField: ({ position }: FieldOwnerState & { position?: 'start' | 'end' }) => ({
                            name: position === 'start' ? 'Início Emissão' : 'Final Emissão',
                            autoComplete: 'off',
                        }),
                    }}
                />
            </Grid>

            <Grid sx={{ flex: 1 }}>
                <CissNumberField
                    label="Código"
                    value={filterCodigo.value}
                    onChange={(e) => setFilterCodigo((oldState: FilterValuesProps) => ({ ...oldState, value: e.target.value }))}
                    preventEmptyField={false}
                />
            </Grid>
        </Filter>
    );
}
